import { getToken, refreshTokenSilently } from "@gtmhub/auth";
import { IHttpInterceptor, IHttpInterceptorFactory, IPromise, IQService, IRequestConfig, jwt } from "angular";

export class TokenRefreshInterceptor implements IHttpInterceptor {
  constructor(private $q: IQService, private jwtHelper: jwt.IJwtHelper) {}

  public request = (config: IRequestConfig): IRequestConfig | IPromise<IRequestConfig> => {
    if (getToken() && this.jwtHelper.isTokenExpired(getToken())) {
      return this.$q.when(refreshTokenSilently()).then(() => config);
    }
    return config;
  };
  public static factory(): IHttpInterceptorFactory {
    const factory = ($q: IQService, jwtHelper: jwt.IJwtHelper) => new TokenRefreshInterceptor($q, jwtHelper);
    factory.$inject = ["$q", "jwtHelper", "appConfig"];
    return factory;
  }
}
